/* istanbul ignore file */

/* eslint-disable react/require-default-props */
import React from 'react';
import { func, string } from 'prop-types';
import Heading from '../heading/Heading';
import Link from '../link/Link';
import Button from '../button';

var ContactUsContent = function ContactUsContent(_ref) {
  var dataAnalyticsLabel = _ref.dataAnalyticsLabel,
      dataAnalyticsId = _ref.dataAnalyticsId,
      inputValue = _ref.inputValue,
      onChangeFunc = _ref.onChangeFunc;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "wrapper-1",
    "data-analytics-id": dataAnalyticsId,
    "data-analytics-label": dataAnalyticsLabel,
    "data-test-id": "contact-us-content"
  }, /*#__PURE__*/React.createElement(Heading, {
    color: "#61686e",
    variant: 6
  }, "Call us"), /*#__PURE__*/React.createElement(Link, {
    className: "NavLink anchor",
    href: "tel:+18008274277",
    target: "_self"
  }, "1-800-827-4277"), /*#__PURE__*/React.createElement("p", {
    className: "paragraph"
  }, "For medical or psychiatric emergencies, call 911 immediately.")), /*#__PURE__*/React.createElement("div", {
    className: "wrapper-2"
  }, /*#__PURE__*/React.createElement(Heading, {
    className: "email-us",
    color: "#61686e",
    variant: 6
  }, "Email us"), /*#__PURE__*/React.createElement("p", {
    className: "paragraph"
  }, "Please do not use this form to convey personal or medical information."), /*#__PURE__*/React.createElement("form", {
    className: "form_contact-sharp"
  }, /*#__PURE__*/React.createElement("div", {
    className: "block-1"
  }, /*#__PURE__*/React.createElement("label", {
    className: "label",
    htmlFor: "sharp-subject"
  }, "I need help with"), /*#__PURE__*/React.createElement("input", {
    name: "sharp-subject",
    maxLength: "200",
    size: "20",
    title: "sharp-subject",
    className: "input",
    "data-test-id": "input",
    type: "text",
    value: inputValue,
    onChange: onChangeFunc,
    autoComplete: "off"
  })), /*#__PURE__*/React.createElement("div", {
    className: "block-2"
  }, /*#__PURE__*/React.createElement("label", {
    className: "label",
    htmlFor: "first-name"
  }, "First name"), /*#__PURE__*/React.createElement("input", {
    name: "first-name",
    maxLength: "200",
    size: "20",
    title: "first-name",
    className: "input",
    "data-test-id": "input",
    type: "text",
    value: inputValue,
    onChange: onChangeFunc,
    autoComplete: "off"
  })), /*#__PURE__*/React.createElement("div", {
    className: "block-3"
  }, /*#__PURE__*/React.createElement("label", {
    className: "label",
    htmlFor: "last-name"
  }, "Last name"), /*#__PURE__*/React.createElement("input", {
    name: "last-name",
    maxLength: "200",
    size: "20",
    title: "last-name",
    className: "input",
    "data-test-id": "input",
    type: "text",
    value: inputValue,
    onChange: onChangeFunc,
    autoComplete: "off"
  })), /*#__PURE__*/React.createElement("div", {
    className: "block-4"
  }, /*#__PURE__*/React.createElement("label", {
    className: "label",
    htmlFor: "email"
  }, "Email"), /*#__PURE__*/React.createElement("input", {
    name: "email",
    maxLength: "200",
    size: "20",
    title: "email",
    className: "input",
    "data-test-id": "input",
    type: "text",
    value: inputValue,
    onChange: onChangeFunc,
    autoComplete: "off"
  })), /*#__PURE__*/React.createElement("div", {
    className: "block-5"
  }, /*#__PURE__*/React.createElement("label", {
    className: "label",
    htmlFor: "phone"
  }, "Phone", /*#__PURE__*/React.createElement("span", {
    className: "callout"
  }, "Optional")), /*#__PURE__*/React.createElement("input", {
    name: "phone",
    maxLength: "200",
    size: "20",
    title: "phone",
    className: "input",
    "data-test-id": "input",
    type: "text",
    value: inputValue,
    onChange: onChangeFunc,
    autoComplete: "off"
  })), /*#__PURE__*/React.createElement("div", {
    className: "block-6"
  }, /*#__PURE__*/React.createElement("label", {
    className: "label",
    htmlFor: "message"
  }, "Message"), /*#__PURE__*/React.createElement("textarea", {
    name: "message",
    type: "text",
    size: "20",
    value: inputValue,
    title: "message",
    className: "text-area",
    autoComplete: "off",
    onChange: onChangeFunc
  })), /*#__PURE__*/React.createElement("div", {
    className: "captcha"
  }, "Reserved for CAPTCHA"), /*#__PURE__*/React.createElement(Button, {
    className: "send-message",
    alignment: "align-center",
    buttonName: "side-drawer-submit",
    buttonValue: "Send message",
    theme: "cobalt",
    setWidth: "150px",
    expand: false,
    size: "small",
    variant: "primary"
  }, /*#__PURE__*/React.createElement("span", {
    className: "text"
  }, "Send message")), /*#__PURE__*/React.createElement("div", {
    className: "divider"
  }), /*#__PURE__*/React.createElement(Heading, {
    className: "find-other-numbers",
    color: "#61686e",
    variant: 6
  }, "Find other numbers"), /*#__PURE__*/React.createElement(Link, {
    className: "NavLink anchor",
    href: "/phone-numbers.cfm",
    target: "_self"
  }, "View our phone directory"))));
};

ContactUsContent.propTypes = {
  /**
   * Define a dataAnalyticsLabel
   */
  dataAnalyticsLabel: string,

  /**
   * Define a dataAnalyticsId
   */
  dataAnalyticsId: string,

  /**
   * Define a inputValue
   */
  inputValue: string,

  /**
   * Invoke a function for input fields
   */
  onChangeFunc: func
};
export default ContactUsContent;